import { Component, Input } from '@angular/core';
import { InfoCardType } from '@legacy/common-ui-models';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
@Component({
  selector: 'wl-collapsable-info-block',
  templateUrl: './collapsable-info-block.component.html',
  styleUrls: ['./collapsable-info-block.component.scss'],
  standalone: true,
  imports: [AutomationIdDirective, FaIconComponent],
})
export class CollapsableInfoBlockComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() type: InfoCardType = 'info';
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() title?: string;
}
